<script setup lang="ts">
const SIZES = {
  sm: 'size-9 text-[12px] leading-[1.45] font-semibold',
  md: 'size-11 text-[14px] leading-[1.4] font-semibold',
  lg: 'size-[72px] text-[18px] leading-[1.2] font-bold',
} as const;

withDefaults(
  defineProps<{
    initials: string;
    size?: keyof typeof SIZES;
    pressed?: boolean;
  }>(),
  { size: 'sm' },
);
</script>

<template>
  <span
    class="text-accent-encre flex shrink-0 items-center justify-center rounded-full"
    :class="[SIZES[size], pressed ? 'bg-accent-appui' : 'bg-accent']"
  >
    {{ initials }}
  </span>
</template>
